import { render, staticRenderFns } from "./starLevelSearch.vue?vue&type=template&id=0be488cd&scoped=true"
import script from "./starLevelSearch.vue?vue&type=script&lang=js"
export * from "./starLevelSearch.vue?vue&type=script&lang=js"
import style0 from "./starLevelSearch.vue?vue&type=style&index=0&id=0be488cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be488cd",
  null
  
)

export default component.exports